<template>
  <div class="row">
    <div class="col-md-3">
      <md-field>
        <span class="md-prefix">$</span>
        <label>Credito solar</label>
        <md-input v-model="financed_amount"></md-input>
      </md-field>

      <md-field>
        <span class="md-prefix">$</span>
        <label>Pago inicial</label>
        <md-input></md-input>
      </md-field>

      <md-field>
        <span class="md-prefix">$</span>
        <label>Comisiones de cliente</label>
        <md-input></md-input>
      </md-field>

      <md-field>
        <span class="md-prefix">$</span>
        <label>Pagos de cliente</label>
        <md-input></md-input>
      </md-field>
    </div>
    <div class="col-md-3">
      <md-field>
        <label>PID</label>
        <md-input v-model="pid"></md-input>
      </md-field>
      <md-field>
        <span class="md-prefix">$</span>
        <label>Total</label>
        <md-input></md-input>
      </md-field>

      <md-button class="md-primary md-raised" @click="getInfo()">Consultar</md-button>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "SolarCreditVerification",
  data: () => ({
    pid: 1953,
    financed_amount: 0
  }),
  computed: {
    ...mapState("devTools", ["api"])
  },
  methods: {
    async getInfo() {
      try {
        const {data} = await axios.get(`${this.api.endpointBase}/v2/projects/${this.pid}?with=finance`)
        const { applicant_trx } = await axios.get(`${this.api.endpointBase}/v1/applicant-trx?filter[trx_type][]=C110&filter[trx_type][]=C110&filter[project_id][]=${this.pid}`);
        console.log(applicant_trx)
        this.financed_amount = data.finance.financed_amount;
      } catch (e) {

      }
    }
  }
}
</script>

<style scoped>

</style>
